import {fonts, rainbowColors} from "../../../../../../../../app.style";

export const regularDiscountedPriceStyle = {
  textDecoration: "line-through",
  ...rainbowColors.red,
  ...fonts.spartan14
}